import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const emreportsApi = createApi({
  reducerPath: 'emreportsApi',
  baseQuery: btBaseQuery,
  tagTypes: ['EMReports'],
  keepUnusedDataFor: 10,

  endpoints: (builder) => ({
    getEMAttLog: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `emreports/attlog/${cid}/${fdt}/${tdt}`
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetEMAttLogQuery } = emreportsApi;
